import { Controller } from 'stimulus';

import { rowFilterService } from '../libs/row_filter_service';
import { uiService } from '../libs/ui_service';

export default class extends Controller {
  openModal() {
    $('#filters-modal').modal({
      closeClass: 'icon-remove',
      clickClose: false,
    });

    // Create filters in the modal and update previously (maybe) selected filters
    // unless no filter selected (yet)
    if (Object.keys(rowFilterService.selectedFilters).length < 1) {
      rowFilterService.createFilters();
      rowFilterService.updateFilter(0, '');
    }
  }

  clearFilters() {
    rowFilterService.clearAllSelectedFilters();
    uiService.updateTable();
    uiService.applyDefaultTableSort();
    uiService.closeModals();
  }

  applyFilters() {
    uiService.updateTable();
    uiService.applyDefaultTableSort();
    uiService.closeModals();
  }
}
